<template>
  <div class="online">
    <div class="banner">
      <img src="../../assets/images/online/banner.png" alt />
    </div>
    <!-- 切换选项 -->
    <div class="optionList">
      <ul class="option">
        <li
          v-for="(item, i) in optionData"
          :class="{ active : onlineActive === i }"
          :key="i"
          @click="onlineActive = i, $router.push({ path: item.path }), saveNavState(i)"
        >{{item.name}}</li>
      </ul>
    </div>
    <!-- 列表 -->
    <div class="contentList">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      onlineActive: 0,
      optionData: [
        { name: 'H5项目', path: 'H5' },
        { name: '推文文章', path: 'Article' },
        { name: '海报', path: 'Poster' }
      ]
    }
  },
  created() {},
  mounted() {
    if (window.sessionStorage.getItem('onlineActive') === null) {
      window.sessionStorage.setItem('onlineActive', 0)
    }
    this.onlineActive = parseInt(window.sessionStorage.getItem('onlineActive'))
  },
  methods: {
    // 保存链接的激活状态
    saveNavState(active) {
      window.sessionStorage.setItem('onlineActive', active)
      this.onlineActive = active
    }
  }
}
</script>

<style scoped>
.online {
  width: 100%;
}
.online .banner {
  width: 100%;
  height: 240px;
  position: relative;
  overflow: hidden;
}
.online .banner img {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  width: auto;
  height: 100%;
}
.online .optionList {
  width: 100%;
  background-color: #fff;
  height: 60px;
  border-bottom: 1px solid #dcdcdc;
}
.online .optionList .option {
  max-width: 1100px;
  margin: 0 auto;
  line-height: 60px;
  font-size: 22px;
  font-weight: 600;
  display: flex;
  justify-content: center;
}
.online .optionList .option li {
  width: 120px;
  height: 60px;
  text-align: center;
  box-sizing: border-box;
  cursor: pointer;
}
.online .optionList .option li.active {
  border-bottom: 3px solid #000;
}
.online .contentList {
  width: 100%;
  max-width: 1100px;
  margin: 30px auto;
}
</style>
